export const makeBold = (item: string, keyword: string[]) => {
  const re = new RegExp(`(${keyword.join('|')})`, 'gi');
  return item.replaceAll(re, '<b>$1</b>');
};
